module.exports = __webpack_public_path__ + "static/media/Logo.b58002e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/Logo.png
// module id = 128
// module chunks = 0